import type { IOorkV1ProcedureCustomControlData } from '@common/interfaces/ophthalmology/OorkAndOcrk/oorkV1ProcedureCustomControlData';
import type { BooleanRadioGroupFormGroupFieldProps } from '@frontend/components/fields/BooleanRadioGroupField';
import type { TextAreaFormGroupFieldProps } from '@frontend/components/fields/TextAreaField';
import type { ValidationErrors } from '@frontend/utils/validation';

export interface IOorkV1ProcedureProps {
    customControlData: IOorkV1ProcedureCustomControlData;
    errors: ValidationErrors;
    handleChangeCustomControl: <T = IOorkV1ProcedureCustomControlData>(values: Partial<T>) => Promise<void>;
    validateOneCustomControl: (name: keyof IOorkV1ProcedureCustomControlData) => Promise<void>;
}

export const defaultBooleanRadioGroupFormGroupFieldProps: Pick<BooleanRadioGroupFormGroupFieldProps, 'type'> = {
    type: 'radio',
};

export const defaultTextAreaFormGroupFieldProps: Pick<TextAreaFormGroupFieldProps, 'variant'> = {
    variant: 'outline',
};
